import _Map from "@babel/runtime-corejs2/core-js/map";
var divisionCodeDisplayNameMap = new _Map().set('ELECTRICITY', 'Electricity').set('NATURAL_GAS', 'Natural gas').set('HOT_WATER', 'Hot water').set('LPG', 'LPG').set('BROADBAND', 'Broadband').set('SOLAR', 'SOLAR').set('OTHER', 'OTHER');

var getDisplayName = function getDisplayName(divisionCode) {
  return divisionCodeDisplayNameMap.get(divisionCode);
};

var getDisplayNameV2 = function getDisplayNameV2(serviceType) {
  return divisionCodeDisplayNameMap.get(serviceType);
};

export { getDisplayName, getDisplayNameV2 };